import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { SubHeaderService } from '../../../../../core/services/sub-header.service';
import { SidePanelService } from '../../../../../common/services/side-panel.service';
import { Organization, OrganizationEventType } from '../../../../../common/models/organization.model';
import { NoteRelatedItemType } from "../../../../../common/models/note_relatedItemType.enum";
import { OrganizationService } from '../../../../../common/services/organization.service';
import { AuthService } from '../../../../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteStrategy } from '../../../../../core/models/routing.model';
import { Subscription, Observable } from 'rxjs';
import { LunaClaimValues } from '../../../../../models/user-identity.model';

@Component({
    selector: 'organization-wrapper',
    templateUrl: './organization-wrapper.component.html',
    styleUrls: ['./organization-wrapper.component.scss'],
    standalone: false
})
export class OrganizationWrapperComponent implements OnDestroy, OnInit {
    organization: Organization;
    typeDescrip: string;
    subscriptions: Subscription = new Subscription();

	noteTypes = NoteRelatedItemType;

	private _editingEnabled: boolean = false;
	private _editingActive: boolean = false;

	get canEdit(): boolean {
		return this._editingEnabled;
	}

	get editingActive(): boolean {
		return this._editingActive;
	}

	set editingActive(value: boolean) {
		this._editingActive = value;
	}


    get isCancelled(): boolean {
        let cancelled: boolean = false;
        if (this.organization) {
            return !this.organization.isActive;
        }

        return cancelled;
    }

    get cancellationDate(): Date | null {
        if (this.isCancelled) {
            return this.organization.cancellationDate;
        }
        return null;
	}

	get enforcementExhausted(): boolean {
		return this.organization != null && this.organization.status == 'D';
	}

	get enforcementExhaustedDate(): Date | null {
		if (this.enforcementExhausted) {
			return this.organization.dateEnforcementExhausted;
		}
		return null;
	}	

	private _typeValues: any[] = [];

	get typeValues(): any[] {
		if (this._organizationService == null || this._organizationService.domain == null || this._organizationService.domain.values == null) return [];
		if (this._typeValues.length == 0) {
			this._organizationService.domain.values.forEach(v => {
				if (v.Definition.includes('Other (Specify)') == false) {
					this._typeValues.push(v);
				}
			});
			this._typeValues.unshift({ Code: "", Definition: "--SELECT--" });
		}
		return this._typeValues;
	}

	get typeDescription(): string {
		if (this.typeValues.length == 0 || this.typeDescrip.length == 0) return this.typeDescrip;
		let type = this.typeValues.find(t => t.Code == this.typeDescrip);
		if (type == null) return this.typeDescrip;
		return type.Definition;
	}

    get showCriticalNotes(): boolean {
        if (this._activatedRoute == null) return false;
        if (this._activatedRoute.firstChild == null || this._activatedRoute.firstChild.routeConfig == null || this._activatedRoute.firstChild.routeConfig.path == null) return true;
        if (this._activatedRoute.firstChild.routeConfig.path != null && this._activatedRoute.firstChild.routeConfig.path.toLocaleLowerCase() != '') return false;
        return true;
    }

    constructor(
        public subHeaderService: SubHeaderService,
        public _sidePanelService: SidePanelService,
        public _router: Router,
        public _activatedRoute: ActivatedRoute,
        public _organizationService: OrganizationService,
		public location: Location,
		private auth: AuthService

    ) {
        //hack to fix another hack in view-dashboard.component.ts that prevents reusing of route. this allows the page
        //to load new data without reloading the page
        this._router.routeReuseStrategy = new RouteStrategy();
        this.organization = this._activatedRoute.snapshot.data.organization;
		this.typeDescrip = (this.organization.typeCode) != null ? this.organization.typeCode : '';
		this.subHeaderService.updateSubHeader({ title: 'Manage External Organization' });
	}

	ngOnInit() {

	}

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
	}

    goBack(): void {
        this._sidePanelService.toggleSidePanel(false);
        this.location.back();
	}

	updateEdit(enable: boolean): void {
		console.log('update edit updated to', enable);
		this._editingEnabled = enable;
	}

	update(): void {
		this._organizationService.updateEntityType(this.typeDescrip);
		this._editingActive = false;
	}
}
